// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Service imports
import { MPCacheRegistrationService } from '../../../_services/shared-services/mp-cache-registration-service';
// Constant imports
import { URLConstants } from '../../../_constants/url-constants';
import { CacheDuration } from '../../../_constants/cache-duration';
import { BatchDetailResultDto } from '../_models/cb-batches/batch-detail-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../_services/shared-services/mp-cache-registration-service";
export class CBBatchDetailService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getBatchDetail(params) {
        const url = `${URLConstants.ccCBBatchApiBaseUrl}/detail${params.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, params.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(BatchDetailResultDto, response)));
    }
}
CBBatchDetailService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CBBatchDetailService_Factory() { return new CBBatchDetailService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: CBBatchDetailService, providedIn: "root" });
